import { Layout, Alert, Button, message, Modal, Divider, Affix } from "antd";
import React from "react";
import SiteNav from "./SiteNav";
import SiteSearchBar from "./SiteSearchBar";
import SiteFooter from "./SiteFooter";
import DropArea from "../layouts/DropArea";
import { apiCall } from "../utils/Api";
export default function Site(props) {

    const { getGlobals = () => { }, getMenu = () => { }, globalTarget = false, containerRef = {}, globals = [], selected = "", setSelected = () => { }, open = false, menus = [], setEditing = () => { }, editing = false, content = [], setContent = () => { }, getContent = () => { }, updateContent = () => { }, updateGlobals = () => { } } = props;
    const { view = "desktop", setView = () => { }, page = { id: 0, is_v1: false }, setPage = () => { } } = props;

    // highlight elements while editing...
    let search_style = (selected === "search_bar") ? { position: "relative", zIndex: "600", "border": "2px dashed deeppink" } : {};
    let nav_style = (selected === "nav_bar") ? { position: "relative", zIndex: "600", "border": "2px dashed deeppink" } : {};
    let footer_style = (selected === "footer_bar") ? { position: "relative", zIndex: "600", "border": "2px dashed deeppink" } : {};
    let status_style = {
        maxWidth: "1248px",
        margin: "0 auto",
        textAlign: "right"
    }

    if (editing) {
        search_style.pointerEvents = "none";
        nav_style.pointerEvents = "none";
        footer_style.pointerEvents = "none";
        status_style.pointerEvents = "none";
    } else {
        search_style.pointerEvents = "auto";
        nav_style.pointerEvents = "auto";
        footer_style.pointerEvents = "auto";
        status_style.pointerEvents = "auto";
    }

    const activatePage = (_id) => {
        apiCall("site_content/switchPageToV3", { page_id: _id }, (_status, _result) => {
            if (_status) {
                getMenu(_id)
                message.success("Page activated.");
            } else {
                message.error(_result.error);
            }
        })
    }

    const findDraftContent = (_id) => {
        let _ret = false;
        if (Array.isArray(content) && content.length > 0) {
            for (let i = 0; i < content.length; i++) {
                let { visibility = "visible" } = content[i];
                if (visibility !== "visible") {
                    _ret = true;
                }
            }
        }
        return _ret;
    }

    const activatePageWarn = (_id) => {

        let draft = findDraftContent();



        Modal.confirm({
            title: "Activate page",
            icon: <></>,
            content: <>
                <Divider dashed style={{ "margin": "10px 0px" }} />
                {(draft && <Alert style={{ "padding": "10px 15px", "marginBottom": "12px" }} type="warning" description={<>One or more elements on this page are marked as <strong>Draft</strong> and will not be visible to customers.</>} />)}

                <Alert style={{ "padding": "10px 15px", "marginBottom": "12px" }} type="error" description={<>
                    <p>This action will immediately remove any previous content and replace it with the new content.</p>
                    <p><strong>This action is irreversible.</strong> Proceed only if you have reviewed and approved the new content. </p>
                </>} />

            </>,
            okText: "Proceed",
            onOk: () => {
                activatePage(_id)
            }
        })
    }

    const revertPage = (_id) => {
        apiCall("site_content/switchPageBackToV1", { page_id: _id }, (_status, _result) => {
            if (_status) {
                getMenu(_id)
                message.success("Page deactivated.");
            } else {
                message.error(_result.error);
            }
        })
    }

    const revertPageWarn = (_id) => {
        Modal.confirm({
            title: "Warning",
            content: <>
                <p>This action will render current content inactive and revert to the page's previous state.</p>
                <p>Proceed only if intended. </p>
            </>,
            okText: "Proceed",
            onOk: () => {
                revertPage(_id)
            }
        })
    }
    

    return (
        <div>
            <div className="s">
                {(open && <div style={{ "position": "absolute", "marginTop": "-25px", "color": "#fff" }}><small> {(globalTarget) ? "Global Banner" : "Page: " + page.name}</small></div>)}
                {((page.is_v1 && open) && <Alert showIcon={false} type="error" message={<div style={status_style}><small>This page is not live. &nbsp; <Button onClick={() => activatePageWarn(page.id)} type="primary" size="small"><small>Activate</small></Button></small></div>} banner />)}
                {((!page.is_v1 && page.v1_page_id && page.type === "custom" && open) && <Alert showIcon={false} type="info" message={<div style={status_style}><small>This page currently live. &nbsp; <Button onClick={() => revertPageWarn(page.id)} type="primary" size="small"><small>Deactivate</small></Button></small></div>} banner />)}
                <div style={search_style}>
                    <div id="bm-notification"></div>
                    <SiteSearchBar editing={editing} menus={menus} open={open} page={page} setPage={setPage} selected={selected} containerRef={containerRef} globals={globals} content={content} record={globals.find(item => item.component === "search_bar")} view={view} />
                </div>
                <div style={nav_style}>
                    <SiteNav containerRef={containerRef} globalTarget={globalTarget} open={open} globals={globals} record={globals.find(item => item.component === "nav_bar")} menus={menus} page={page} setPage={setPage} view={view} />
                </div>
                <Layout>
                    <div className="bm-background-color">
                        <div className="bm-background" style={{ "minHeight": (open) ? "calc(100vh - 330px)" : "" }}>
                            <Layout.Content>
                                <div style={{ "height": (globalTarget || !open) ? "auto" : "0px", "overflow": (!globalTarget || !open) ? "auto" : "hidden" }}>
                                    <DropArea containerRef={containerRef} getGlobals={getGlobals} getContent={getContent} globals={globals} updateGlobals={updateGlobals} globalTarget={globalTarget} setView={setView} view={view} menus={menus} selected={selected} setSelected={setSelected} setEditing={setEditing} editing={editing} setContent={setContent} updateContent={updateGlobals} content={globals} open={open} page={page.id} location="global" />
                                </div>
                                <div style={{ "height": (!globalTarget || !open) ? "auto" : "0px", "overflow": (!globalTarget || !open) ? "auto" : "hidden" }}>
                                    <DropArea containerRef={containerRef} getGlobals={getGlobals} getContent={getContent} globals={globals} updateGlobals={updateGlobals} globalTarget={globalTarget} setView={setView} view={view} menus={menus} selected={selected} setSelected={setSelected} setEditing={setEditing} editing={editing} setContent={setContent} updateContent={updateContent} content={content} open={open} page={page.id} location="main" />
                                </div>
                            </Layout.Content>
                        </div>
                    </div>
                </Layout>
                <div style={footer_style}>
                    <SiteFooter globals={globals} record={globals.find(item => item.component === "footer_bar")} view={view} />
                </div>
            </div>
        </div>
    )
}